module.exports = __webpack_public_path__ + "static/img/vip.748f34c1.png";